import { render } from "./NotarialCaseComponent.vue?vue&type=template&id=ccea5270&scoped=true"
import script from "./NotarialCaseComponent.vue?vue&type=script&lang=js"
export * from "./NotarialCaseComponent.vue?vue&type=script&lang=js"

import "./NotarialCaseComponent.vue?vue&type=style&index=0&id=ccea5270&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccea5270"]])

export default __exports__